import React from 'react';

const LoginsetupPresentational = ({ page }) => {
	return <>{page}</>;
};
export default LoginsetupPresentational;